import BusinessVerticalsService from "@/api/services/businessVerticals";
import { toCamelCase, isMpcpCategory } from "@estaly/ui";

const SEATS_OR_FURNITURE_CATEGORIES = ["seats", "furniture", "seats_v2", "furniture_v2"];

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    hasMpcpOffers(state) {
      return !!state.index?.length && state.index.some((businessVertical) => isMpcpCategory(businessVertical.category));
    },
    hasSeatsOrFurniture(state) {
      return (
        !!state.index?.length &&
        state.index.some((businessVertical) => SEATS_OR_FURNITURE_CATEGORIES.includes(businessVertical.category))
      );
    },
    hasBvWarrantyExtension(state) {
      return (
        !!state.index?.length &&
        state.index.some((businessVertical) => businessVertical.category === "bv_warranty_extension")
      );
    },
    hasOnlyBvWarrantyExtension(state) {
      return (
        !!state.index?.length &&
        state.index.every((businessVertical) => businessVertical.category === "bv_warranty_extension")
      );
    },
    hasExternalPosOnlySubscription(_state, getters) {
      return getters.hasSeatsOrFurniture || getters.hasOnlyBvWarrantyExtension;
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { storeId, enabled, page, includes } = {}) {
      const response = await BusinessVerticalsService.fetchIndex({ page, storeId, enabled, includes });

      if (!response?.success) return response;

      const data = toCamelCase(response.data);

      commit("setIndex", data);
      return data;
    },
  },
};
